import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

import {
  BehaviorSubject,
  buffer,
  debounceTime,
  filter,
  fromEvent,
  map,
  Observable,
  tap,
} from 'rxjs';

import { AppVersionService } from './app-version.service';

@Component({
	selector: 'app-version',
	templateUrl: './app-version.component.html',
	styleUrls: ['./app-version.component.less'],
	standalone: false,
})
export class AppVersionComponent implements OnInit, AfterViewInit {

	@ViewChild('versionButton')
	public versionButton: ElementRef<HTMLButtonElement>;

	@Input()
	public frontendVersion: string;

	@Input()
	public frontendBranchName: string;

	@Input()
	public packageVersion: string;

	public backendVersion: Observable<string>;

	public show$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


	constructor(public versionService: AppVersionService) { }

	public ngOnInit() {

		this.backendVersion = this.versionService.getAppBackendVersion();

	}

	public ngAfterViewInit() {

		const click$ = fromEvent(this.versionButton.nativeElement, 'click');

		click$
			.pipe(
				buffer(click$
					.pipe(
						debounceTime(300),
					),
				),
			)
			.pipe(
				map((eventArray: Array<Event>) => eventArray.length),
				filter((clickCount: number) => clickCount > 5),
			)
			.pipe(
				tap((count: number) => {
					console.log(count);
					this.show$$.next(true);
				}),
			)
			.subscribe();

	}

	public close(): void {
		this.show$$.next(false);
	}
}
